import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ImportDataService {
  private _isImportPanelOpen$ = new BehaviorSubject<boolean>(false);

  /**
   * Observable to track whether Import Data panel is open
   */
  get isImportPanelOpen$(): Observable<boolean> {
    return this._isImportPanelOpen$.asObservable();
  }

  /**
   * Open the Import Data panel
   */
  openImportPanel(): void {
    this._isImportPanelOpen$.next(true);
  }

  /**
   * Close the Import Data panel
   */
  closeImportPanel(): void {
    this._isImportPanelOpen$.next(false);
  }
}
